import { isFunction } from 'lodash';

import {
  API_CALL,
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS
} from '../constants/actionTypes';
import { UNAUTHORISED_DS_API } from '../constants/customEvents';

function apiMiddleware() {
  return ({ dispatch }) => next => action => {
    if (action.type === API_CALL) {
      const { catch: catchFunc, request, then: thenFunc, type, ...remainder } = action;

      const requestPromise = isFunction(request) ? request() : request;
      if (!(requestPromise instanceof Promise)) {
        throw new Error(
          `Actions of type ${API_CALL} must request property of type Promise or a function that returns a Promise.`
        );
      }

      requestPromise.then(
        res => {
          dispatch({
            ...remainder,
            ...res,
            type: API_CALL_SUCCESS
          });
          if (thenFunc) {
            thenFunc();
          }
        },
        res => {
          // when there is an unauthorised api response emit this event, there is a listner for it that will try to obtain a new token
          if (res.status === 401) {
            document.body.dispatchEvent(
              new window.CustomEvent(UNAUTHORISED_DS_API, { detail: { action, res } })
            );
          }

          dispatch({
            ...remainder,
            ...res,
            type: API_CALL_FAILURE
          });
          if (catchFunc) {
            catchFunc();
          }
        }
      );

      return next({
        ...remainder,
        type: API_CALL_REQUEST
      });
    }

    return next(action);
  };
}

export default apiMiddleware;
